import i18next from "i18next"

export const getFieldRequiredMessage = () => i18next.t("Field is required")

export const getFieldOnlyLetters = () =>
  i18next.t("Field can only contain letters")

export const getValidArabicMessage = () =>
  i18next.t("Please enter a valid Arabic name")

export const getNoSpaceMessage = () =>
  i18next.t("This field cannot contain white spaces")

export const getEmailMessage = () => i18next.t("Please Enter Your Email")

export const getValidEmail = () =>
  i18next.t("Please enter a valid email address")

export const getMin6PasswordMessage = () =>
  i18next.t("Password must be at least 8 characters")

export const getPasswordComplexityMessage = () =>
  i18next.t(
    "Password must include an uppercase letter, a lowercase letter, a number, and a special character"
  )

export const getPasswordMatchMessage = () => i18next.t("Passwords must match")

export const getArabicDescMessage = () =>
  i18next.t("Please enter a valid Arabic description")

export const getArabicLinkMessage = () =>
  i18next.t("Please enter a valid Arabic link label")

export const getDisplayNumMessage = () =>
  i18next.t("Display Order must be a number")

export const getMinimumNegMessage = () =>
  i18next.t("Minimum value cannot be negative")

export const getValidNumMessage = () => i18next.t("Please enter a valid number")

export const getOnlyNumMessage = () =>
  i18next.t("This field must contain only numbers")

export const getValue0To100 = () => i18next.t("Value must be between 0 and 100")

export const getQtyNum = () => i18next.t("Quantity must be a number")

export const getQtyPositive = () => i18next.t("Quantity must be positive")

export const getMinExact1 = () => i18next.t("Minimum value must be exactly 1")

export const getMaxExact1 = () => i18next.t("Maximum value must be exactly 1")

export const getMaxMustGreaterMin = () =>
  i18next.t("Maximum value must be greater than minimum value")

export const getAlfaNumericChar = () =>
  i18next.t("Only alphanumeric characters are allowed")

export const getMinOneCustomer = () =>
  i18next.t("At least one customer must be selected")

export const getMinOneLocation = () =>
  i18next.t("At least one branch must be selected")

export const getMinOneSetting = () =>
  i18next.t("At least one setting must be selected")

export const getMinOneItemGroup = () =>
  i18next.t("Please select at least one item group")

export const getOnlyNumAndChar = () =>
  i18next.t("Only numbers and characters are allowed (no spaces)")

export const getValueBt3To10 = () => i18next.t("Value must be between 3 and 10")
export const getValueBt1To1000 = () =>
  i18next.t("Value must be between 1 and 1000")

export const getValueBt1To10 = () => i18next.t("Value must be between 1 and 10")

export const getGreaterOrEqual0 = () =>
  i18next.t("Value must be greater than or equal to 0")

export const getDialCodeStart = () => i18next.t("Dial code must start with +")

export const getExpiredDateMsg = () =>
  i18next.t("Expiry date must be later than start date")

export const getInvalidFormat = () => i18next.t("Invalid email format")

export const getStartEndTimeDifferentMsg = () =>
  i18next.t("Start and end times cannot be the same")